import { IMAGE_SIZES } from "@config/ImageSizes";

const displayImageSize = (imageUrl, size) =>
    imageUrl != null && IMAGE_SIZES.includes(size)
        ? imageUrl.replace(".jpg", `_w${size}.jpg`)
        : imageUrl;

export default displayImageSize;
